import axios from 'axios'
import Qs from 'qs'
import store from 'store'
import $_ from '../util/util.js';
import {
  Message
} from 'element-ui';

// 创建axios实例
const http = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

//请求拦截器
http.interceptors.request.use(
  function(config) {
    if (store.get('tkn')) {
      config.headers.tkn = store.get('tkn');
    }
    if (process.env.NODE_ENV == 'development') {
      //开发环境
      config.headers['Domain-Name'] = 'localhost';
    } else {
      config.headers['Domain-Name'] = window.location.host;
    }
    //config.headers['Domain-Name'] = 'localhost';
    config.headers['Channel'] = 'pc';
    config.data = Qs.stringify(config.data);
    return config;
  },
  function(error) {
    return Promise.reject(error);
  })

//响应拦截器
http.interceptors.response.use(
  function(response) {
    var data = response.data,
      header = response.headers,
      tkn = header.tkn,
      provinceId = header.provinceid;
    if (!$_.isEmpty(tkn)) {
      //重新返回了token
      store.set('tkn', tkn)
    }
    if (!$_.isEmpty(provinceId)) {
      //重新返回了token
      provinceId = parseInt(provinceId);
      store.set('provinceId', provinceId)
    }
		//返回了 tkn 但是未返回省份ID 说明用户未选择省份
		if (!$_.isEmpty(tkn) && $_.isEmpty(provinceId)) {
			//弹出框选择省份
      store.set('pross', true)
		}
    if (response.data.code == 400 || response.data.code == 500) {
      Message.error(response.data.message);
    }
    return response.data;
  },
  function(error) {
    return Promise.reject(error);
  })

export default http



// WEBPACK FOOTER //
// ./src/util/http.js